import * as model from '../model';
import { getI18n } from 'react-i18next';
import es from './../assets/lang/es.json'
import eu from './../assets/lang/eu.json'

export function getLanguage(lang: string| undefined): model.Lang {
    let langs: model.Lang[] = getAvailableLanguages();
    let value: model.Lang | undefined = undefined;
    if (lang) {
        value = langs.find((language: model.Lang) => {
            return language.key === lang || language.app === lang || language.content === lang
        }) || getDefaultLanguage();
    }
    if (value === undefined) {
        value = getDefaultLanguage();
    }
    return value;   
}

export function getAvailableLanguages(): model.Lang[] {
    let langs: model.Lang[] = [];
    langs.push(es);
    langs.push(eu);
    return langs;
}

export function getDefaultLanguage(): model.Lang {
    return getAvailableLanguages()[0];
}

export function changeLanguage(languageId: string) {
    getI18n().changeLanguage(languageId);
}